











































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { TranslateResult } from 'vue-i18n';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Student } from '@/models/student/student';
import { studentModule } from '@/store/modules/entities/student.module';
import { RecommendationLetterStep } from '@/store/modules/entities/recommendation-letter.module';
import Vue from 'vue';
import GLoading from '@/components/GLoading.vue';
import { RecommendationLetter } from '@/models/student/recommendation-letter';
import { DateUtils } from '@/utils/date.utils';
import GRecommendationLetterList from './GStudentRecordRecommendationLetterList.vue';
import GStudentRecordRecommendationLetterStudentInfoStep from './GStudentRecordRecommendationLetterStudentInfoStep.vue';
import GStudentRecordRecommendationLetterPolicySelectionStep from './GStudentRecordRecommendationLetterPolicySelectionStep.vue';
import GStudentRecordRecommendationLetterGeneration from './GStudentRecordRecommendationLetterGeneration.vue';
import { recommendationLetterModule, ConfirmationStep, StudentInfoSectionType } from '@/store/modules/entities/recommendation-letter.module';

@Component({
  name: 'GStudentRecordRecommendationLetter',
  components: {
    GLoading,
    GRecommendationLetterList,
    GStudentRecordRecommendationLetterStudentInfoStep,
    GStudentRecordRecommendationLetterPolicySelectionStep,
    GStudentRecordRecommendationLetterGeneration,
  },
})
export default class GStudentRecordRecommendationLetter extends mixins(GPageBase) {
  @Prop() student!: Student;
  ConfirmationStep = ConfirmationStep;
  DateUtils = DateUtils;
  isCreateNew = false;
  lastStep = 1;
  RecommendationLetterStep = RecommendationLetterStep;

  mounted() {
    this.onCurrentStepChange();
    this.focusCurrentTextarea();
    this.adjustTextareaStyle();
    recommendationLetterModule.clearState();
    studentModule.fetchStudentRecommendationLetters(this.student.studentID);
  }

  @Watch('student')
  onStudentChange() {
    recommendationLetterModule.clearState();
  }

  @Watch('currentStep')
  onCurrentStepChange() {
    // ステップの背景色を変更。CSSだけではできないため。
    const stepsElements = Array.from(document.querySelectorAll('.ivu-steps-title'));
    const headElements = Array.from(document.querySelectorAll('.ivu-steps-head'));
    stepsElements.concat(headElements).forEach(el => {
      if (el instanceof HTMLElement) {
        el.style.backgroundColor = '#f0f5ff';
      }
    });
    this.adjustTextareaStyle();
  }

  get steps(): TranslateResult[] {
    return [this.$i18n.t('STUDENT_INFO'), this.$i18n.t('GENERATE_RECOMMENDATION_LETTER_POLICY'), this.$i18n.t('CONFIRM_OR_EDIT_RECOMMENDATION_LETTER')];
  }

  get currentStep(): RecommendationLetterStep {
    return recommendationLetterModule.currentStep;
  }

  get currentStudentInfoSection(): StudentInfoSectionType {
    return recommendationLetterModule.currentStudentInfoSection;
  }

  get currentStudentInfoCompleted(): boolean {
    return recommendationLetterModule.currentStudentInfoCompleted;
  }

  get generationPreferences(): string[] {
    return recommendationLetterModule.generationPreferences;
  }

  get selectedGenerationPreferences(): string[] {
    return recommendationLetterModule.selectedGenerationPreferences;
  }

  get isBusy(): boolean {
    return recommendationLetterModule.isBusy;
  }

  get confirmationStep(): ConfirmationStep {
    return recommendationLetterModule.confirmationStep;
  }

  get pastRecommendationLetters(): RecommendationLetter[] {
    return this.$store.state.studentModule.recommendationLetters;
  }

  get hasNextStudent(): boolean {
    return studentModule.studentKartePrevNext.next !== null;
  }

  get targetInstitution(): string {
    return recommendationLetterModule.targetInstitution;
  }

  get loadingText(): string {
    return recommendationLetterModule.loadingText;
  }

  @Watch('currentStudentInfoSection')
  onCurrentStudentInfoSectionChange() {
    this.focusCurrentTextarea();
  }

  focusCurrentTextarea(): void {
    this.$nextTick(() => {
      const studentInfoStep = this.$refs.studentInfoStep as any;
      if (studentInfoStep) {
        const refName = `textarea-${this.currentStudentInfoSection}`;
        const inputRef = studentInfoStep.$refs[refName];

        if (Array.isArray(inputRef) && inputRef[0] instanceof Vue) {
          const v: any = inputRef[0];
          const el = v.$el as HTMLElement;
          v.focus();
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (studentInfoStep.$refs.studentInfoNextButton) {
          const v: any = studentInfoStep.$refs.studentInfoNextButton;
          const el = v.$el as HTMLElement;
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
    this.adjustTextareaStyle();
  }

  adjustTextareaStyle(): void {
    this.$nextTick(() => {
      const inputElements = document.querySelectorAll('.ivu-input');
      inputElements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.borderRadius = '32px';
          el.style.resize = 'none';
          el.style.padding = '16px';
        }
      });
    });
  }

  createNewRecommendationLetter() {
    this.isCreateNew = true;
    recommendationLetterModule.clearState();
    recommendationLetterModule.setCurrentStep(RecommendationLetterStep.StudentInfo);
    // AIGROW2-988 推薦書アップデート 直近の入力内容を新規作成時に反映する
    // 過去に作成した RecommendationLetter が存在している場合にのみ実行
    if (studentModule.recommendationLetters.length)  {
      const latest: RecommendationLetter = studentModule.latestRecommendationLetter;
      recommendationLetterModule.setAchievements(latest.generationRequest.achievements);
      recommendationLetterModule.setMostSignificantAchievement(latest.generationRequest.mostSignificantAchievement);
      recommendationLetterModule.setPersonalityEpisode(latest.generationRequest.personalityEpisode);
    }
    this.$nextTick(() => {
      this.focusCurrentTextarea();
      this.adjustTextareaStyle();
      this.onCurrentStepChange();
    });
  }

  handleBackToList() {
    this.isCreateNew = false;
    if (this.currentStep === RecommendationLetterStep.Generation) {
      this.lastStep = 0;
      recommendationLetterModule.clearState();
    } else {
      this.lastStep = this.currentStep;
      recommendationLetterModule.setCurrentStep(RecommendationLetterStep.List);
    }
    studentModule.fetchStudentRecommendationLetters(this.student.studentID);
  }

  get hasInputData(): boolean {
    return recommendationLetterModule.hasInputData;
  }
}
